import { Routes } from '@angular/router';

import { auraRoutes } from './aura-routes';
import { reportingRoutes } from './reporting-routes';
import { onlineAccountRoutes } from './rsw-account-ui-routes';
import { wpRoutes } from './unified-wp-routes';

export const routes: Routes = [
  ...auraRoutes,
  ...wpRoutes,
  ...reportingRoutes,
  ...onlineAccountRoutes,
  {
    path: 'search',
    children: [':query', ''].map((path) => ({
      path,
      loadChildren: () =>
        import('rs-search/Module').then((m) => m.RemoteEntryModule),
    })),
  },
  {
    path: 'sustainability',
    loadChildren: () =>
      import('rs-sustainability/Module').then((m) => m.RemoteEntryModule),
  },
  {
    // this page used to exist in V1 but no longer does. links possibly still exist in old emails
    path: 'shop/contact-us',
    pathMatch: 'full',
    redirectTo: 'contact-us',
  },
  {
    // rs-shop matcher. ignores /shop but catches all sub routes
    matcher: (url) =>
      url.length > 1 && url[0]?.path === 'shop' ? { consumed: [url[0]] } : null,
    loadChildren: () =>
      import('rs-shop/Module').then((m) => m.RemoteEntryModule),
  },
  {
    path: '',
    loadChildren: () =>
      import('@digital-platform/rs-frontend/shell').then(
        (m) => m.RsFrontendShellModule
      ),
  },
  {
    path: '',
    outlet: 'header',
    loadChildren: () =>
      import('rs-header/Module').then((m) => m.RemoteEntryModule),
  },
  {
    path: '',
    outlet: 'footer',
    loadChildren: () =>
      import('rs-footer/Module').then((m) => m.RemoteEntryModule),
  },
];
